/* eslint-disable max-statements */
import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import FeatureSpecification from "./component";
import Modal from "../../shared/modal";
import CloseButton from "../../shared/icon-cross";
const FeatureSpecificationModal = ({ isOpen, onClose, content, handleFeatureSpecsModal }) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <div styleName={"styles.modalWrap"}>
                <div styleName={"styles.modalHeaderWrap"}>
                    <div styleName={"styles.modalHeader"}>
                        <h4>All Features and specifications</h4>
                        <span styleName={"styles.close"}>
                            <CloseButton onClickHandler={handleFeatureSpecsModal} type="modalClose" />
                        </span>
                    </div>
                    <FeatureSpecification
                        content={content}
                        isSearchbarFocused = {false}
                        handleFeatureSpecsModal={handleFeatureSpecsModal}
                        isModal={true}
                    />
                </div>
            </div>
        </Modal>
    );
};

FeatureSpecificationModal.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    content: PropTypes.object,
    featuresAndSpecsRef: PropTypes.object,
    handleFeatureSpecsModal: PropTypes.func
};

export default FeatureSpecificationModal;
